<template>
  <span>
    <v-dialog
      v-if="currentUser.permissions.add_to_collections === true"
      v-model="editCollectionDialog"
      max-width="600"
      class="image-popup"
    >
      <template #activator="{ on }">
        <v-icon right title="Edit collection" v-on="on"
          >mdi-pencil-box-outline</v-icon
        >
      </template>
      <v-btn
        color="primary"
        icon
        class="popup-close"
        @click="editCollectionDialog = false"
      >
        <v-icon>mdi-close-circle-outline</v-icon>
      </v-btn>
      <v-card>
        <div class="diaog-inner pa-10 grey lighten-5">
          <v-card-title>Edit collection</v-card-title>

          <v-card-text>
            <v-form>
              <v-text-field
                v-if="currentUser.permissions.add_to_collections === true"
                v-model="collectionOldName"
                label="Collection name"
              >
                <v-icon slot="append" color="primary">mdi-plus</v-icon>
              </v-text-field>

              <v-btn color="primary" class="mt-2" @click="editCollection"
                >Save</v-btn
              >
            </v-form>
          </v-card-text>
        </div>
      </v-card>
    </v-dialog>
  </span>
</template>

<script>
import { mapGetters } from "vuex";
import { CollectionsService } from "@/common/api.service";
import toast from "@/services/toast";

export default {
  name: "EditCollectionDialog",
  data: () => ({
    userCanAdd: false,
    editCollectionDialog: false,

    newCollectionName: "",
    response: {},
    isLoading: false,
    search: null,
  }),

  computed: {
    collectionOldName: {
      get() {
        return this.collection.name;
      },
      set(val) {
        this.newCollectionName = val;
      },
    },
    ...mapGetters(["activeExpClient", "currentUser", "collection"]),
  },
  methods: {
    async editCollection() {
      return CollectionsService.update(this.collection.id, {
        name: this.newCollectionName,
        client_id: this.activeExpClient.id,
        client_can_view: true,
        short_description: "Hold",
      })
        .then((resp) => {
          if (resp) {
            this.collection.name = this.newCollectionName;
            toast.success(resp.data.message);
          }
          this.editCollectionDialog = false;
        })
        .catch((error) => {
          this.editCollectionDialog = false;
          console.log(error);
        });
    },
  },
};
</script>
